export enum FunctionPermissionType {
    Common = 1,
    System = 2
}